import React from 'react';

import { DuplicateButton } from 'craft/containers/FloatingMenu/commons/DuplicateButton';
import { useFlow } from 'craft/state';

export const DuplicateStepButton = ({
  flowId,
  stepId,
  tooltipPlacement,
}: {
  flowId: string;
  stepId: string;
  tooltipPlacement: 'top' | 'bottom';
}) => {
  const { onDuplicateStep } = useFlow(flowId);

  const onDuplicate = () => {
    onDuplicateStep(stepId);
  };

  return <DuplicateButton onClick={onDuplicate} tooltipPlacement={tooltipPlacement} />;
};
